import { render } from "./ShowTitle.vue?vue&type=template&id=65ef36ed"
import script from "./ShowTitle.vue?vue&type=script&lang=js"
export * from "./ShowTitle.vue?vue&type=script&lang=js"
script.render = render

export default script